import Header from './Header';
import Footer from './Footer';
import MiniCart from './MiniCart';
import SupportWidget from './SupportWidget';
import TelegramTabBar from './TelegramTabBar';
import type { CartState } from '@/hooks/useCart';
import { useAppEnvironment } from '@/hooks/AppEnvironmentContext';

export interface LayoutProps {
  children: React.ReactNode;
  cart: CartState;
  cartOpen: boolean;
  onCartToggle: () => void;
  onCartClose: () => void;
  onCartRemove: (id: string) => void;
  onCartUpdateQuantity: (id: string, quantity: number) => void;
}

export default function Layout({
  children,
  cart,
  cartOpen,
  onCartToggle,
  onCartClose,
  onCartRemove,
  onCartUpdateQuantity,
}: LayoutProps) {
  const { isTelegram } = useAppEnvironment();

  return (
    <div className={`min-h-screen flex flex-col bg-cream ${isTelegram ? 'telegram-miniapp-shell' : ''}`}>
      {!isTelegram && <Header cartCount={cart.count} onCartToggle={onCartToggle} />}
      {!isTelegram && (
        <MiniCart
          cart={cart}
          isOpen={cartOpen}
          onClose={onCartClose}
          onRemove={onCartRemove}
          onUpdateQuantity={onCartUpdateQuantity}
        />
      )}
      <main className={isTelegram ? 'telegram-miniapp-main flex-1' : 'flex-1'}>
        {children}
      </main>
      {isTelegram ? (
        <TelegramTabBar cartCount={cart.count} />
      ) : (
        <>
          <SupportWidget />
          <Footer />
        </>
      )}
    </div>
  );
}
